import React,{useState, useEffect,useRef,useMemo} from 'react'
import { SBADropDown } from "../../../../UiComponents/SBADropDown";
import { EditInternalFee, AddInternalFee } from '../SetuptTab/CalculationTab';
import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import {getClientMgmtFee,getPortfolioListAPI } from "../../../../../config/apiConfig";
import { sbaAxios } from "../../../../utils/sbaAxios";
import { exportToExcelUsingRef } from '../../../../utils/excelExporter';
import download from "../../../../../Images/download.svg";
export const SBA = ({IsFee}) => {
  const [SBAFeeRowData, setSBAFeeRowData] = useState([]);
  const [showAddDrawer, setShowAddDrawer] = useState(false);
  const [showEditDrawer, setShowEditDrawer] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [feeData,setFeeData]=useState([]);
  const [mgmtFeeId,setmgmtFeeId]=useState();
  const [portfolio,setPortfolio]=useState([]);
  const [selectedportfolio,setselectedportfolio]=useState({PortfolioId:"-1",PortfolioName:"All"});
  const feesRef = useRef();
  useEffect(() => {
  getPortfolio();
   getFees();
  },[])
  const handlefeedata=(dt)=>
  {
    setFeeData(dt);
  }
  const handleSBAFeedata = (data) => {
    setSBAFeeRowData(data);
  }
  const getFormattedDate=(value)=>{
    return value ? moment(value).format("MM-DD-YYYY") : "";
  };
  const getFees = async () => {
    try {

        const response = await sbaAxios({
            url: `${getClientMgmtFee}`,
            method: 'get',
        });
        
if(selectedportfolio.PortfolioId!="-1")
{
        const dt=response.filter(item => item.PortfolioId ===selectedportfolio.PortfolioId);
        const data=  dt?.map(item=>(
          {...item,
            CreatedDate:getFormattedDate(item.CreatedDate),
           
          })) || [];
        setFeeData(data);
}
else{
 const dt= response?.map(item=>(
    {...item,
      CreatedDate:getFormattedDate(item.CreatedDate),
     
    })) || [];
  setFeeData(dt);
}
    } catch (error) {
        console.error("Error fetching get billing data from API:", error);
    }
};
const FormatpercentCurrencyGrid = (params) => {
  
  var num = params.value;

  if (num !== undefined && num != null) {
    if (num === 0) {
      num = 0;
    }

     
      const isNegative = num < 0;

     
      const formattedValue = isNegative
        ? `${(num).toLocaleString('en-US', {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4,
          })} %`
        : `${num.toLocaleString('en-US', {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4,
          })} %`;

     
      const style = isNegative ? { color: 'red' } : null;

      return <span style={style}>{formattedValue}</span>;
  
  } else {
    return <span></span>; // Wrap num in a span
  }
};
  const actionCellRenderer = (params) => {
    return (
      <div className="actions-cell">
        <i
          className="fas fa-edit"
          style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }}
          onClick={() => {
            setShowEditDrawer(true);
            setSelectedRowId(params.data.rowId);
            setmgmtFeeId(params.data.ClientMgmtFeeId);
          }}
        ></i>
        <i
          className="fa fa-trash"
          style={{ color: "red", margin: "0 8px", cursor: "pointer" }}
          onClick={() => {
            const updatedData = SBAFeeRowData.filter(row => row.rowId !== params.data.rowId)
            handleSBAFeedata(updatedData);
          }}
        ></i>
      </div>
    );
  };

  const SBAFeeColumnDef = [
    { headerName: "Portfolio Name", field: "PortfolioName" },
    { headerName: "Asset Name", field: "AssetName" },
    { headerName: "Share Class Name", field: "ShareClassName" },
    { headerName: "Management Fee", field: "FeeValue",cellClass: 'currencyFormat',cellRenderer: FormatpercentCurrencyGrid  },
    { headerName: "Created Date", field: "CreatedDate" ,valueFormatter:(e)=>(moment(e.value).format('MM/DD/YYYY'))},
    { headerName: "Created By", field: "ModifiedBy" },
    // {
    //   headerName: "Action",
    //   field: "Action",
    //   cellRenderer: actionCellRenderer,
    //   sortable: false,
    //   filter: false
    // }
  ];

  const defaultColumnDef = {
    flex: 1,
    minWidth: 100,
    resizable: true,
    enableValue: true,
    enableRowGroup: true,
    sortable: true,
    autoHeaderHeight: true
  };
  const getPortfolio = async () => {
    try {
  
        const response = await sbaAxios({
            url: `${getPortfolioListAPI}`,
            method: 'get',
        });
        
        const modifiedData = [{ PortfolioName: 'All', PortfolioId: -1 }, ...response];
        setPortfolio(modifiedData);
    } catch (error) {
        console.error("Error fetching get portfolio from API:", error);
    }
  };
  const excelStyles = useMemo(() => { 
    return [
         
          {
              id: 'currencyFormat',
              numberFormat: { format: '0.0000%',
              },
          },
          {
            id: 'date',
            numberFormat: {
                format: 'MM-dd-YYYY'
            }
        }
      ];
  }, []);
  const PortfolioDDChng = (e) => {
      
    if (e.value) {
      setselectedportfolio(e.value);
      
    }
  
  };
  const GoClick=()=>
  {
    getFees();
  }
  
  return (
    <div className='container-fluid'>
      <div className='row justify-content-start'>
        <div className="col">
          <div className="mb-4">                
            <div style={{display:'flex', alignItems:'center', gap:'15px'}}>
            <div style={{width:'250px'}}>
              <label className="label">Portfolio</label>
              <SBADropDown
                 data={portfolio}
                 textField={"PortfolioName"}
                 valueField={"PortfolioId"}
                 onChange={PortfolioDDChng}
                 popupSettings={{ className: "modalDD" }}
                 value={selectedportfolio}
              
              ></SBADropDown>
            </div>
              <span className="fw-medium mt-4">
                <button 
                  type="submit" 
                  className="p-sm-btn"
                  onClick={GoClick} 
                >Go
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
      
      <label className="label">Internal Fees</label>
      <div className="d-flex gap-1 justify-content-end">
      <button className="p-sm-btn" onClick={() => { setShowAddDrawer(true) }}>Add New</button>
      <button
               
                className="p-sm-btn"
                onClick={() => {
                  exportToExcelUsingRef(
                    feesRef,
                    "Fees List.xlsx"
                  );
                }}
              >
                <img src={download} alt="" /> Export
              </button>
    </div>
      <div className="row">
        <div className="w-100 ag-theme-alpine m-1" style={{ height: '300px' }}>
          <AgGridReact   ref={feesRef}  excelStyles={excelStyles} columnDefs={SBAFeeColumnDef} rowData={IsFee?feeData:SBAFeeRowData} defaultColDef={defaultColumnDef}></AgGridReact>
        </div>
      </div>
      <AddInternalFee
        open={showAddDrawer}
        setOpen={setShowAddDrawer}
        handleSBAFeedata={handleSBAFeedata}
        handlefeedata={handlefeedata}
        rowData={SBAFeeRowData}
        IsFee={IsFee}
        
      >
      </AddInternalFee>
      {showEditDrawer &&
        <EditInternalFee
          open={showEditDrawer}
                  setOpen={setShowEditDrawer}
                  handleSBAFeedata={handleSBAFeedata}
                  handlefeedata={handlefeedata}
          rowData={SBAFeeRowData}
          rowId={selectedRowId}
          IsFee={IsFee}
          mgmtFeeId={mgmtFeeId}
        ></EditInternalFee>}
    </div>
  )
}
